import { render, staticRenderFns } from "./RedirectButton.vue?vue&type=template&id=32ab2691&"
import script from "./RedirectButton.vue?vue&type=script&lang=ts&"
export * from "./RedirectButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports